import { memo } from 'react'
import * as Styled from './styled'
import { ISidebarItemProps } from './types'
import { Text } from 'common-components'
import { NEW_LABEL_PNG } from 'consts/images'

const SidebarItem: React.FC<ISidebarItemProps> = ({
  icon,
  label,
  isActive,
  isNewLabel,
  rootRef
}) => (
  <Styled.SidebarItem ref={rootRef} $isActive={isActive}>
    {icon}
    {/* The label's color is owned by SidebarItem's active/hover rules (it needs
        the active state), so no color prop here — it would be overridden. */}
    <Text type="h5">{label}</Text>
    {isNewLabel && <Styled.NewLabel src={NEW_LABEL_PNG} alt="New Label" />}
  </Styled.SidebarItem>
)

export default memo(SidebarItem)
